import { createSlice } from '@reduxjs/toolkit';

const initialStoreState = {
	storeAllLink: [],
	storeAllBrand: [],
	storeAllConversion: [],
	storeAllReward: [],
	storeAllTransaction: [],
	storeAllBalanceHistory: [],
};

const storeSlice = createSlice({
	name: 'store',
	initialState: initialStoreState,
	reducers: {
		setStoreData(state, action) {
			// LINKS
			state.storeAllLink =
				action.payload.storeAllLink ??
				(state.storeAllLink || initialStoreState.storeAllLink);
			// BRANDS
			state.storeAllBrand =
				action.payload.storeAllBrand ??
				(state.storeAllBrand || initialStoreState.storeAllBrand);
			// CONVERSIONS
			state.storeAllConversion =
				action.payload.storeAllConversion ??
				(state.storeAllConversion || initialStoreState.storeAllConversion);
			// REWARDS
			state.storeAllReward =
				action.payload.storeAllReward ??
				(state.storeAllReward || initialStoreState.storeAllReward);
			// TRANSACTIONS
			state.storeAllTransaction =
				action.payload.storeAllTransaction ??
				(state.storeAllTransaction || initialStoreState.storeAllTransaction);
			// BALANCE HISTORY
			state.storeAllBalanceHistory =
				action.payload.storeAllBalanceHistory ??
				(state.storeAllBalanceHistory ||
					initialStoreState.storeAllBalanceHistory);
		},
		reset() {
			return initialStoreState;
		},
	},
});

export const storeActions = storeSlice.actions;
export default storeSlice.reducer;
